import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import { Topbar } from '../../components/include/Topbar';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';
import Loader from '../../components/common/Loader';

const Add_facility = () => {
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const fileInputRef = useRef();
    const [selectedFile, setSelectedFile] = useState(null);
    const [deletedFiles, setDeletedFiles] = useState([])
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const isAccessible = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;




    const [formData, setFormData] = useState({
        name: "",
        purpose: "",
        image: [],
        description: "",
    })

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = true;
        if (!formData.purpose) newErrors.purpose = true;
        // if (!formData.image) newErrors.image = true;
        if (!formData.description) newErrors.description = true;
        if (!selectedFile || selectedFile.length === 0) {
            newErrors.image = "At least one image is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if ((name === 'name') && !/^[A-Za-z ]*$/.test(value)) {
            return; // Prevent updating the form data if non-alphabetic character is entered
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;
        setLoader(true);

        const form = new FormData();
        if (params.id) form.append("id", params.id);
        form.append("name", formData.name);
        form.append("purpose", formData.purpose);
        form.append("image", formData.image);
        form.append("description", formData.description);

        if (selectedFile?.length) {
            selectedFile.forEach((file) => {
                form.append("image", file);
            });
        }
        deletedFiles.forEach((file) => {
            form.append("deletedFiles[]", file);
        });


        Postdata(HttpService.facility_add, form).then((res) => {
            if (res.status === 200) {
                navigate(`/education`, {
                    replace: true,
                    state: { currentTab: "Facilities" },
                });


                // dispatch(message(res.message));
            }
            setLoader(false)
        });
        console.log("Submitted as FormData:", formData);
    }

    const fetchData = () => {
        setLoader(true)
        Postdata(HttpService.facility_show, { id: params.id }).then((res) => {
            if (res.status === 200) {
                setFormData({
                    name: res.data.name,
                    purpose: res.data.purpose,
                    image: res.data.image,
                    description: res.data.description,
                })
                setSelectedFile(res.data.image);


            } else {

                dispatch(message(res.message));
            }
            setLoader(false)
        });
    }


    useEffect(() => {
        if (location.state?.type === "edit") {
            fetchData()
        }
    }, [])

    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }

    console.log(location.state?.type, "++++++++++++")
    if (!isAccessible) {
        return <Error403Page />
    }
    return (
        <>
            <Topbar title={location.state?.type == "edit" ? "Edit Facility" : "Add Facility "} aerrow={true} />

            <div className="p-6 bg-gray-100 min-h-screen">
                <form onSubmit={(e) => handleSubmit(e)}>


                    {/* Inline Inputs */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        {/* Performance Year */}
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">
                                Facility Name<span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter Facility Name"
                                className="input-field"
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                            {errors.name && (
                                <span className="text-red-500 text-sm">Name Required</span>
                            )}
                        </div>

                        <div className='md:col-span-2'>
                            <label className="block mb-1 font-medium text-gray-700">
                                Facility Purpose<span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="purpose"
                                placeholder="Write Here"
                                className="input-field"
                                value={formData.purpose}
                                onChange={handleInputChange}
                            />
                            {errors.purpose && (
                                <span className="text-red-500 text-sm">Purpose Required</span>
                            )}
                        </div>

                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">

                        <div className="">
                            <label className="block mb-1 font-medium text-gray-700">
                                Facility Image<span className="text-red-500">*</span>
                            </label>
                            <div className="relative flex-1">
                                <input
                                    type="text"
                                    placeholder="Select Image"
                                    className="input-field"
                                    readOnly
                                //   value={pdfFile?.name || ""}
                                />
                                <button
                                    type="button"
                                    onClick={() => fileInputRef.current.click()}
                                    className="absolute top-1/2 right-3 -translate-y-1/2 text-orange-600 font-semibold"
                                >
                                    Upload
                                </button>
                            </div>
                            {/* Hidden File Input */}
                            <input
                                type="file"
                                ref={fileInputRef}
                                name="file"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => {
                                    const files = Array.from(e.target.files);
                                    const maxFiles = 10;
                                    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes

                                    let newFiles = [...(selectedFile || [])];
                                    

                                    for (let file of files) {
                                        if (file.size > maxSize) {
                                            setErrors({image: `File  is larger than 5 MB.`});
                                            break;
                                        }
                                        if (newFiles.length >= maxFiles) {
                                            setErrors({image:`You can only upload up to ${maxFiles} images.`});
                                            break;
                                        }
                                        newFiles.push(file);
                                    }


                                    setSelectedFile(newFiles);
                                    e.target.value = ""; // reset input so same file can be re-selected
                                }}
                                className="hidden"
                            />
                            {errors.image && (
                                <span className="text-red-500 text-sm">{errors.image}</span>
                            )}
                        </div>

                    </div>
                    <div className="flex gap-[14px] mt-3">
                        {console.log("selectedFile", selectedFile)}
                        {selectedFile && selectedFile?.map((file, index) => (
                            <div
                                key={index}
                                className="relative  rounded-md flex items-center justify-center"
                            >
                                <img
                                    src={
                                        typeof file === "string"
                                            ? file
                                            : URL.createObjectURL(file)
                                    }
                                    alt="img" className="w-20 h-20" />
                                <button
                                    type="button"
                                    onClick={() => {
                                        // Filter out the specific file object based on its properties
                                        setSelectedFile((prev) => prev.filter((item, i) => i !== index));
                                        
                                        const filePath = file.split("Dev/")[1];
                                        
                                        if (filePath) {
                                            const fullFilePath = `Dev/${filePath}`;
                                            setDeletedFiles((prev) => [...prev, fullFilePath]);
                                        }
                                    }}
                                    className="absolute -top-2 -right-2 bg-black text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-800"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                    </div>
                    <div>
                        <label className="block mb-1 font-medium text-gray-700">
                            Facility Description<span className="text-red-500">*</span>
                        </label>
                        <textarea
                            name="description"
                            placeholder="Write Here"
                            className="input-field"
                            value={formData.description}
                            onChange={handleInputChange}
                        />
                        {errors.description && (
                            <span className="text-red-500 text-sm">Description Required</span>
                        )}
                    </div>

                    <div className="w-full flex justify-center gap-3 mb-2 mt-4">
                        <button
                            type="submit"
                            className="button-field-primary"
                            style={{ width: "30%" }}
                            disabled={loader}
                        >
                            {loader ? 'Please wait...' : ('Submit')}
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default Add_facility